<template>
  <div style="padding-bottom: 80px;">

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container pa-4 style="position: relative;">
        <!-- MOBILE TOOLBAR -->
        <div v-if="$vuetify.breakpoint.xs" :class="['c-flex-c']">
          <div class="c-flex-r align-center">
            <v-btn
            icon
            round 
            @click="goBack">
              <v-icon color="color1">arrow_back</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <span class="text-ellipsed">
              {{ definition.name }}
            </span>
            <v-spacer></v-spacer>

          </div>
        </div>

        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

          <v-breadcrumbs class="pl-0">
            <v-breadcrumbs-item to="/dashboard/">
              Home
            </v-breadcrumbs-item>
            <span class="pl-2 pr-2">/</span>
            <v-breadcrumbs-item to="/inventory/inventory-definitions">
              Inventory definitions
            </v-breadcrumbs-item>
            <span class="pl-2 pr-2">/</span>
            <v-breadcrumbs-item disabled>
              {{ id }}
            </v-breadcrumbs-item>

          </v-breadcrumbs>

          <div class="c-flex-r align-center">
            
          </div>
          <div class="c-flex-r align-center">
            <img src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="80px">
            <div class="c-flex-c">
              <div class="title text--text ml-1">
              {{ definition.name }}
            </div>
          </div>
            
          </div>
          <!-- save button -->
          <div>
            
          </div>
        </div>
      </v-container>
      <div class="c-hr"></div>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->


    <!-- MAIN CONTENT -->
    <div>
      <v-container>

        <v-row>
          <v-btn 
          text
          @click="$router.push('/inventory/inventory-definitions/edit/' + id)">
          <v-icon small class="mr-2">mdi-pencil</v-icon>
            EDIT
          </v-btn>
          <v-btn 
          text
          @click="onDelete">
          <v-icon small class="mr-2">mdi-delete</v-icon>
            DELETE
          </v-btn>
        </v-row>
      
        <v-layout wrap>
          <v-flex xs12 sm6 pa-2>

            <v-card style="overflow: hidden;">
              <inventory-card :id="id"></inventory-card>
            </v-card>
          </v-flex>


          <v-flex xs12 sm6 pa-2>
            <v-card style="height: 100%;">
              <build-runner :id="id"></build-runner>
            </v-card>
          </v-flex>

        </v-layout>
        <v-layout wrap>

          <!-- Ingredient of -->
          <v-flex xs12 sm6 pa-2>
            <v-card style="height: 100%;">
              
              
              <ingredient-runner :id="id"></ingredient-runner>
              
            
            </v-card>
          </v-flex>

          <!-- Deliveries -->
          <v-flex xs12 sm6 pa-2>
            <v-card style="height: 100%;">
              <!--
              <delivery-runner :id="id"></delivery-runner>
              -->
            </v-card>
          </v-flex>

          Recent productions?

          Timeline?
        </v-layout>

      </v-container>

    </div>

    <!-- DIALOGS -->
    <history-dialog ref="historyDialog"></history-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import BuildRunner from './components/builds/BuildRunner'
import IngredientRunner from './components/ingredient-of/IngredientRunner'
import InventoryRunner from './components/inventory/InventoryRunner'
import DeliveryRunner from './components/deliveries/DeliveryRunner'
import HistoryDialog from '@/components/v/inventory/history-dialog'
import InventoryCard from './components/inventory/InventoryRunner'

export default {
  props: ['id'],
  components: {
    'build-runner': BuildRunner,
    'ingredient-runner': IngredientRunner,
    'delivery-runner': DeliveryRunner,
    HistoryDialog,
    InventoryCard
  },
  data () {
    return {
      previousPage: '',
      definition: {},
      inventoryItems: []
    }
  },
  computed: {
    totalInStock () {
      return this.inventoryItems.reduce((a, b) => +a + +b.quantity, 0)
    },
    deliveries () {
      var deliveryItems = Object.values(this.$store.state.db.deliveryItems.items)
      return deliveryItems.reduce((a, i) => {
        if (i.inventory_item_id === parseInt(this.id) && !a.includes(i.delivery_id)) {
          a.push(this.$store.state.db.deliveryItems.items[i.delivery_id])
        }
        return a
      }, [])
    }
  },
  methods: {
    onDelete () {
      var title = 'Delete this definition?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('inventory-definitions/delete', [this.id],
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.$root.$alert('Successfully Deleted', 'This definition has been obliterated!', {}).then(() => {
                this.$router.replace({ path: `/inventory/inventory-definitions/`})
              })
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    goBack () {
      this.$router.replace(this.previousPage)
    },
    openHistoryDialog () {
      this.$refs.historyDialog.open(this.id)
    },
    loadAPI (id) {
      var definition
      var inventory
      axios.all([
        this.$axios.get(`inventory-definitions/${id}`),
        this.$axios.get(`/inventory/definition/${id}/`)
        ])
        .then(axios.spread((_definition, _inventory) => {
          definition = _definition.data
          inventory = _inventory.data.rows
          console.log('definition')
          console.log(definition)
          console.log('inventory')
          console.log(inventory)
          // inputs = inputs_response.data
          this.definition = definition
          this.inventoryItems = inventory
        }))
        .catch(error => this.$root.$errorSnackbar(error))
    }
  },
  created () {
    this.loadAPI(this.id)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousPage = from.path === '/loading' ? '/inventory/inventory-definitions' : from.path
      next()
    })
  },
  beforeRouteUpdate (to, from, next) {
    // called when the route that renders this component has changed,
    // but this component is reused in the new route.
    // For example, for a route with dynamic params `/foo/:id`, when we
    // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
    // will be reused, and this hook will be called when that happens.
    // has access to `this` component instance.

    const id = to.params.id
    console.log('before route update -> ' + id)
    this.loadAPI(id)
    // this.AJAXRequest(id)
    next()
  }
}
</script>

<style scoped>
.block {
  display: inline-block;
  padding: 30px;
  width: 300px;
  border: 1px solid grey;
  border-radius: 6px;
  box-shadow: 0px 1px 5px rgba(0,0,0,0.05);
}
</style>

